export const handleWindowResize = function({commit, state}) {

    renderProportions(commit, state);
    
}

export const downloadImage = function({commit, state}, payload) {
    console.info("Download image " + payload.download);
    var URL = state.config.downloadBaseUrl + payload.view.directory + '/' + payload.download;
    state.downloadRequestedImage = URL;

    if(!state.downloadTermsAccepted) {
        state.downloadTermsVisible = true;

        return false;
    }


    // var win = window.open(URL, "_blank" );
     window.location.assign(URL)
    // state.downloadTermsAccepted = true;
}


function renderProportions(commit, state) {

    console.info("Render proportions " + Date.now());
        
    state.layout.height = window.innerHeight;
    state.layout.width = window.innerWidth;

    var ratio =  state.layout.width / state.layout.height ;
    state.layout.ratio = Number( ratio.toFixed(2) );

    if(state.layout.ratio < 1) {
        state.layout.orientation = 'portrait'
    } else {
        state.layout.orientation = 'landscape'
    }

    // handle screen-type specific parameters
    if(state.layout.width > state.layout.breakpointTablet) { 
        state.layout.type = 'large';
        var margin = state.layout.margin;
        state.layout.viewportWidth = state.layout.width - state.layout.sidebarWidth - state.layout.margin ;
        state.layout.viewportHeight = state.layout.height;
        var gutter = state.layout.margin;
        state.layout.galleryWidth = state.layoutViewportWidth;
        state.layout.galleryHeight = state.layout.height - 2 * state.layout.margin; 
        state.offsetTop = 0;
        state.offsetLeft = 0;
         
    }

    if(state.layout.width <= state.layout.breakpointTablet && state.layout.width > state.layout.breakpointMobile) { 
        state.layout.type = 'medium' ;
        state.sidebar.status = 0;
        var margin = 0;
        var gutter = 20;

    }

    if(state.layout.width <= state.layout.breakpointMobile) { 
        state.layout.type = 'small' ;
        state.sidebar.status = 0;
        var margin = 0;
        var gutter = 20;
    }

    // viewport width for mobile devices
    if(state.layout.type == 'small' || state.layout.type == 'medium') {
       
        if(state.layout.orientation == 'landscape') {
             state.layout.viewportWidth = state.layout.width - state.layout.mobileSandwichColumn;    
             state.layout.viewportHeight = state.layout.height;
             state.layout.galleryWidth = state.layout.viewportWidth;
             state.layout.galleryHeight = state.layout.viewportHeight  ;
             state.layout.offsetTop = 0;
             state.layout.offsetLeft = state.layout.mobileSandwichColumn;

        }

        if(state.layout.orientation == 'portrait') {

             state.layout.viewportWidth = state.layout.width ;    
             state.layout.viewportHeight = state.layout.height - state.layout.mobileSandwichColumn;
             state.layout.galleryWidth = state.layout.viewportWidth;
             state.layout.galleryHeight = state.layout.viewportHeight - 40 ;
             state.layout.offsetTop = state.layout.mobileSandwichColumn;
             state.layout.offsetLeft = 0;
        }
    }


    var width = state.layout.width - margin*2;
    var height = state.layout.height- margin*2;


    for( var p = 0; p < state.projects.length; p++ ) {
        var totalWidth = 0;

        for( var i = 0; i < state.projects[p].images.length; i++ ) {

            var image = state.projects[p].images[i];
            var imageRatio = image.width/image.height;
            var imageRatio = imageRatio.toFixed(2);

            // handle gutter after first image
            if(i> 0) {
                    state.projects[p].images[i].view.scrollPosition = totalWidth.toFixed(2) + gutter  ;
            } else {
                
                    state.projects[p].images[i].view.scrollPosition = 0;
            }

            // what kind of image do we have
            if( state.layout.ratio > imageRatio   ) {
                state.projects[p].images[i].view.height = height ;
                state.projects[p].images[i].view.width = height * imageRatio ;
            } else {

                state.projects[p].images[i].view.height = width / imageRatio ;
                state.projects[p].images[i].view.width = width ; 

                if(state.projects[p].images[i].view.height > state.layout.viewportHeight - 40) {
                    
                    state.projects[p].images[i].view.height = state.layout.viewportHeight - 40 ;
                    state.projects[p].images[i].view.width = ( state.layout.viewportHeight - 40  )* imageRatio ; 
                } else {

                state.projects[p].images[i].view.height = width / imageRatio ;
                state.projects[p].images[i].view.width = width ; 
                }

            }

            state.projects[p].images[i].view.directory = state.projects[p].directory ;
            totalWidth = totalWidth + state.projects[p].images[i].view.width + margin  ;
        }

       state.projects[p].view.totalWidth = totalWidth;
        
    }
}


export const getCategoryBySlug = function({commit, state}, payload) {
    
    var cat = false;
    for(var i = 0; i < state.categories.length; i++) {
        if(state.categories[i].slug == payload) {
            cat = state.categories[i];
        }
    }

    return cat;
} 



// WEBPACK FOOTER //
// ./src/components/store/actions.js